import React from 'react';
import { personalInfo } from '../mock';
import { Button } from './ui/button';
import { useLanguage } from '../contexts/LanguageContext';
import { translations } from '../translations';

const Hero = () => {
  const { language } = useLanguage();
  const t = translations[language];

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="home" className="min-h-screen flex items-center justify-center bg-gradient-to-b from-gray-50 to-white pt-20">
      <div className="container mx-auto px-6 lg:px-12 py-16">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          <div className="flex justify-center md:justify-start">
            <div className="relative">
              <div className="w-64 h-64 md:w-80 md:h-80 rounded-full overflow-hidden border-4 border-gray-200 shadow-xl">
                <img
                  src={personalInfo.profileImage}
                  alt={personalInfo.name}
                  className="w-full h-full object-cover"
                  style={{ objectPosition: '60% 20%' }}
                />
              </div>
            </div>
          </div>

          <div className="text-center md:text-left space-y-6">
            <div>
              <h1 className="text-4xl md:text-5xl lg:text-6xl font-serif font-bold text-gray-900 mb-4">
                {personalInfo.name}
              </h1>
              <p className="text-xl md:text-2xl text-gray-600 font-serif">
                {t.hero.title}
              </p>
            </div>

            <p className="text-lg text-gray-700 leading-relaxed max-w-2xl">
              {t.hero.description}
            </p>

            <div className="flex flex-col sm:flex-row gap-4 justify-center md:justify-start">
              <Button
                onClick={() => scrollToSection('about')}
                className="bg-gray-900 text-white hover:bg-gray-800 px-8 py-6 text-base font-medium transition-all duration-300"
              >
                {t.hero.learnMore}
              </Button>
              <Button
                onClick={() => scrollToSection('contact')}
                variant="outline"
                className="border-2 border-gray-900 text-gray-900 hover:bg-gray-900 hover:text-white px-8 py-6 text-base font-medium transition-all duration-300"
              >
                {t.hero.getInTouch}
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;